'use client';
import { Anchor } from '../../Anchor';
import { Text } from '../../Text';
import { usePathname } from 'next/navigation';
import type { LinkShape } from '../../Anchor';
import type { styleTypes } from '../../Text';
import { tv } from 'tailwind-variants';

export const menuItemStyles = tv({
	slots: {
		link: 'w-fit py-spacing-2xs px-spacing-xs rounded-2xl flex items-center transition-color duration-fast ease-smooth cursor-pointer',
	},
	variants: {
		active: {
			true: {
				link: 'bg-nav-primary-item-background-hover',
			},
			false: {
				link: 'hover:bg-nav-primary-item-background-hover',
			},
		},
	},
});

export function NavLink(item: LinkShape & { textStyleType?: (typeof styleTypes)[number]; onClick?: () => void }) {
	const pathname = usePathname();

	function matchActiveLink(item: LinkShape) {
		if (!item || !pathname) return false;

		if (!item.href) {
			return false;
		}
		if (item.href === '/') {
			return pathname === '/';
		}
		return pathname.includes(item.href!);
	}
	const active = matchActiveLink(item);

	const { link } = menuItemStyles({ active: active });

	return (
		<li key={`nav-link-${item.label}`}>
			<Anchor className={`${link()} `} href={item.href} onClick={item.onClick}>
				<Text styleType='button-md'>{item.label}</Text>
			</Anchor>
		</li>
	);
}
